// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"styles_containerBox__1pfPa","primary":"styles_primary__3k7TI","secondary":"styles_secondary__oQojO"};